import { getOrganizationResources } from "@/@core/utils/getOrganizationResources";
import definedAbility from "@/ability";
import { formErrorMessage } from "@/utility/formErrorMessage";
export default {
  data() {
    return {
      limitsExceeded: {},
      ability: definedAbility(),
    };
  },
  computed: {
    ignorePaywallLimits() {
      return this.ability.can("ignore", "paywall limits");
    },
  },
  methods: {
    async updateLimitExceededData() {
      try {
        const planFeatures = this.$store.state.billing.subscription.features;

        if (!planFeatures.users && !planFeatures.domains) {
          this.limitsExceeded = {
            teammates: false,
            domains: false,
          };

          return;
        }

        const { teammates, domains } = await getOrganizationResources();
        if (planFeatures.users) {
          this.limitsExceeded.teammates = teammates >= planFeatures?.users;
        } else {
          this.limitsExceeded.teammates = false;
        }

        if (planFeatures.domains) {
          this.limitsExceeded.domains = domains >= planFeatures?.domains;
        } else {
          this.limitsExceeded.domains = false;
        }
      } catch (e) {
        this.$admin.toast.error(formErrorMessage(e, this.$t("error")));
      }
    },
  },
};
